function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement } from "react";
import classnames from "classnames";
import PictureWithLinkComponent from "/components/core/picture-with-link/picture-with-link-component";
import VideoComponent from "components/core/video/video-component";
import { getFileExtension } from "server/services/files-service/files-service";
import { withRouter } from "next/router";
import { withGenericConfig } from "/contexts/generic-config-context";
import { getDynamicAssetConfigForPath } from "/client/services/cluster-config-service/cluster-config-service";
import { getImageUrl } from "/client/services/dynamic-asset-param-service/dynamic-asset-param-service";
import WindowMask from "segments/desktop/core-components/window-mask/window-mask";
import { ConditionalWrapper } from "utils/react";
import { StyledAssetComponent } from "./asset-component.scss";
const MP4 = "mp4";
const GIF = "gif";
const AssetComponent = (props)=>{
    const getAssetsConfig = ()=>{
        const { image, video, useDynamicAsset, clusterConfig, dynamicAssetParamPath, dynamicAssetParam, activePagePath } = props;
        if (dynamicAssetParamPath && dynamicAssetParam) {
            return {
                image: _object_spread_props(_object_spread({}, image), {
                    src: getImageUrl(dynamicAssetParamPath, dynamicAssetParam)
                })
            };
        }
        const dynamicAssetConfig = useDynamicAsset && getDynamicAssetConfigForPath(clusterConfig, activePagePath);
        if (!dynamicAssetConfig) {
            return {
                image,
                video
            };
        }
        if (getFileExtension(dynamicAssetConfig.src) === MP4) {
            return {
                video: _object_spread_props(_object_spread({}, video), {
                    src: {
                        formats: [
                            dynamicAssetConfig.src
                        ]
                    }
                })
            };
        }
        return {
            image: _object_spread({}, image, dynamicAssetConfig)
        };
    };
    const renderAsset = ()=>{
        const { width, convertGifToVideo, imageClassName, assetQuality, hideControls, onStart, onEnded, onDuration, hideBlackBars, onImageLoad } = props;
        const { image, video } = getAssetsConfig();
        if (video === null || video === void 0 ? void 0 : video.src) {
            const { formats } = video.src;
            return /*#__PURE__*/ _jsx(VideoComponent, _object_spread_props(_object_spread({}, video, video.src), {
                formats: formats,
                assetQuality: assetQuality,
                hideControls: hideControls,
                poster: video === null || video === void 0 ? void 0 : video.poster,
                onStart: onStart,
                onEnded: onEnded,
                onDuration: onDuration,
                hideBlackBars: hideBlackBars
            }));
        }
        if (image === null || image === void 0 ? void 0 : image.src) {
            if (getFileExtension(image.src) === GIF && convertGifToVideo) {
                return /*#__PURE__*/ _jsx(VideoComponent, {
                    loop: true,
                    autoPlay: true,
                    formats: [
                        image.src
                    ],
                    assetQuality: assetQuality,
                    ariaLabel: image === null || image === void 0 ? void 0 : image.alt,
                    hideControls: hideControls
                });
            }
            return /*#__PURE__*/ _jsx(PictureWithLinkComponent, _object_spread_props(_object_spread({
                onImageLoad: onImageLoad,
                className: classnames("main-image", imageClassName)
            }, image), {
                specificImageStyle: {
                    width
                },
                assetQuality: assetQuality
            }));
        }
        return null;
    };
    const { width, className, style, useWindowMask, borderRadius } = props;
    const childrenWithWindowMaskClass = (children)=>/*#__PURE__*/ _jsx(WindowMask, {
            children: Children.map(children, (child)=>{
                return /*#__PURE__*/ cloneElement(child, {
                    className: "with-window-mask"
                });
            })
        });
    return /*#__PURE__*/ _jsx(StyledAssetComponent, {
        className: classnames("asset-inner", className),
        style: _object_spread_props(_object_spread({}, style), {
            width,
            borderRadius
        }),
        children: /*#__PURE__*/ _jsx(ConditionalWrapper, {
            condition: useWindowMask,
            wrapper: childrenWithWindowMaskClass,
            children: renderAsset()
        })
    });
};
AssetComponent.defaultProps = {
    convertGifToVideo: false,
    useWindowMask: false
};
export default withGenericConfig(withRouter(AssetComponent));
